import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";
import ModelesContainer from "../../../containers/admin/modeles/ModelesContainer";
import MenuAdmin from "../Menu";

class Modeles extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("imports");
    this.props.setMenuLeftContent(MenuAdmin);
    this.props.setMenuLeftIndex("modeles");
  }
  render() {
    return (
      <Fragment>
        <ModelesContainer {...this.props} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentClientLabel: (state.currentClient || {}).label
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Modeles);



// WEBPACK FOOTER //
// src/pages/imports/imports/Modeles.js